export const PLAN_FREE = "free";
export const PLAN_TRIAL = "trial";
export const PLAN_STANDARD = "standard";
export const PLAN_BASIC = "basic";
export const PLAN_PLUS = "plus";
